import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})

export class ReportComponent implements OnInit {
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authenticationService = inject(AuthenticationService);

  src: string = '';
  iframeSrc: SafeResourceUrl | null = null;
  tenant: string = this.authenticationService.getTenant();

  ngOnInit(): void {
    this.getIframe(this.tenant);  
    console.log('src', this.src);
  }

  getIframe(tenant: string) {
    switch (tenant) {
      case 'CORE':
        this.src = "https://lookerstudio.google.com/embed/reporting/7c523e64-d759-41f3-9fce-83f7c3b751f5/page/nnyfF";
        this.iframeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.src);
        break;
      case 'SIAG': 
        this.src = "https://datastudio.google.com/embed/reporting/ff9b2c06-6160-463e-a463-685372d77713/page/nnyfF";
        this.iframeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.src);
        break;
      case 'EDIDOMUS':
        this.src = "https://datastudio.google.com/embed/reporting/7c1edfec-d1f5-489f-b7cd-e445f085b245/page/nnyfF";
        this.iframeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.src);
        break;
      default:
        this.src = "";
        this.iframeSrc = null;
    }
    
  }

}
